import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, OnInit, computed, inject, input } from '@angular/core';

import { EventModel, EventScoreboard, PeriodGameScore } from '@frontend/sports/betting-offer/feature/model';
import { LiveSectionConfig } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { ValueSliderDirective } from '@frontend/sports/common/ui/value-slider';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

@Component({
    selector: 'ms-period-game-scoreboard',
    templateUrl: './period-game-scoreboard.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, IconCustomComponent, ValueSliderDirective],
})
export class PeriodGameScoreboardComponent implements OnInit {
    private liveSectionConfig = inject(LiveSectionConfig);

    icons = {
        [SportConstant.AmericanFootball]: 'sports-sb-football',
        [SportConstant.Icehockey]: 'sports-sb-power-play',
    };

    isIconEnabled: boolean;

    scoreboard = input.required<EventScoreboard>();
    event = input.required<EventModel>();
    @HostBinding('class') className = 'period-game';

    @HostBinding('class.hidden')
    get hidden(): boolean {
        return !this.score() || isNaN(this.score().participant1.total) || isNaN(this.score().participant2.total);
    }

    isIceHockeyPowerPlay = computed(() => [0, 1].includes(this.scoreboard().powerPlayTeam ?? -1));
    score = computed(() => this.scoreboard().score as PeriodGameScore);
    icon = computed(() => this.icons[this.event().sport.id as keyof typeof this.icons]);
    isFotballSportsId = computed(() => this.event().sport.id === SportConstant.AmericanFootball);

    ngOnInit(): void {
        this.isIconEnabled = this.liveSectionConfig.activeParticipantIconForSports.includes(this.event().sport.id);
    }

    hideIcon(teamIndex: number): boolean {
        return this.isIceHockeyPowerPlay() ? this.scoreboard().powerPlayTeam === teamIndex : this.score().turn !== teamIndex + 1;
    }
}
